'use strict';exports.__esModule = true;exports.receiveStreetSuggestions = exports.receiveSuggestions = undefined;var _axios = require('axios');var _axios2 = _interopRequireDefault(_axios);
var _reduxAct = require('redux-act');
var _reduxLoop = require('redux-loop');
var _constants = require('../../constants');
var _formatApiError = require('../../helpers/formatApiError');var _formatApiError2 = _interopRequireDefault(_formatApiError);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}var

promise = _reduxLoop.Effects.promise;

var receiveSuggestions = (0, _reduxAct.createAction)('/RECEIVE_SUGGESTIONS');
var receiveSuggestionsSuccess = (0, _reduxAct.createAction)('/RECEIVE_SUGGESTIONS_SUCCESS');
var receiveSuggestionsFail = (0, _reduxAct.createAction)('/RECEIVE_SUGGESTIONS_FAIL');
var receiveStreetSuggestions = (0, _reduxAct.createAction)('/RECEIVE_SUGGESTIONS');
var receiveStreetSuggestionsSuccess = (0, _reduxAct.createAction)('/RECEIVE_SUGGESTIONS_SUCCESS');
var receiveStreetSuggestionsFail = (0, _reduxAct.createAction)('/RECEIVE_SUGGESTIONS_FAIL');

var initialState = {
  loading: false,
  loaded: false,
  suggestions: [],
  streetSuggestions: [] };


var receiveHandlerSuccess = function receiveHandlerSuccess(state, response) {return Object.assign({},
  state, {
    loading: false,
    loaded: true,
    suggestions: response.data.predictions,
    streetSuggestions: [] });};


var receiveHandlerFail = function receiveHandlerFail(state, action) {
  var error = (0, _formatApiError2.default)(action, 'Failed receive suggestions');
  return Object.assign({},
  state, {
    loading: false,
    loaded: false,
    error: error,
    streetSuggestions: [] });

};

var fetchReceive = function fetchReceive(params) {return _axios2.default.get(_constants.locationsApiURL + '/address/autocomplete?$limit=5&$skip=0', { params: params }).
  then(receiveSuggestionsSuccess, receiveSuggestionsFail);};

var receiveHandler = function receiveHandler(state, data) {return (0, _reduxLoop.loop)(Object.assign({}, state, { loading: true }), promise(fetchReceive, data));};

var receiveStreetHandlerSuccess = function receiveStreetHandlerSuccess(state, response) {return Object.assign({},
  state, {
    loading: false,
    loaded: true,
    streetSuggestions: response.data.predictions });};


var receiveStreetHandlerFail = function receiveStreetHandlerFail(state, action) {
  console.error(action);
  return Object.assign({},
  state, {
    loading: false,
    loaded: false,
    error: action.error });

};

var fetchStreetReceive = function fetchStreetReceive(params) {return _axios2.default.get(_constants.locationsApiURL + '/address/autocomplete', { params: params }).
  then(receiveStreetSuggestionsSuccess, receiveStreetSuggestionsFail);};

var receiveStreetHandler = function receiveStreetHandler(state, data) {return (0, _reduxLoop.loop)(Object.assign({}, state, { loading: true }), promise(fetchStreetReceive, data));};

var suggestions = (0, _reduxAct.createReducer)(function (on) {
  on(receiveSuggestions, receiveHandler);
  on(receiveSuggestionsSuccess, receiveHandlerSuccess);
  on(receiveSuggestionsFail, receiveHandlerFail);
  on(receiveStreetSuggestions, receiveStreetHandler);
  on(receiveStreetSuggestionsSuccess, receiveStreetHandlerSuccess);
  on(receiveStreetSuggestionsFail, receiveStreetHandlerFail);
}, initialState);exports.


receiveSuggestions = receiveSuggestions;exports.
receiveStreetSuggestions = receiveStreetSuggestions;exports.default =


suggestions;


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/receiveSuggestions.js
// module id = 592
// module chunks = 0